<template>
  <div id="app">
    <h1 v-if="pageTitle" class="page-title">{{ pageTitle }}</h1>
    <cludo-vue :topResult="{ field: 'NewsId', value: topStoryId }" :sortBy="{ 'Date_date': 'desc' }">
      <template #default="{
        searchResult,
        filterParamaters,
        pageLoading,
        topResult,
      }">
        <section class="news-display__wrapper programmes">
          <div>
             <!-- Meta -->
            <div v-if="!pageLoading && filterParamaters?.query" class="programmes__meta">
              <!-- Results Count -->
              <results-count :totalResults="Number(searchResult.TotalDocument)"
                :filterParamaters="filterParamaters" />
            </div>

            <!-- Search Results -->
            <template>
              <div v-if="pageLoading">
                <SearchLoader />
              </div>
              <template v-else>
                <div class="news-display__main">
                  <cludo-vue-banners />
                  <cludo-vue-results v-if="Number(searchResult?.TotalDocument) > 0" :topResult="topResult">
                    <template #loading>
                      <SearchLoader />
                    </template>
                    <template #default="{ searchResult }">
                      <search-result :result="searchResult" :show-thumbnail="showThumbnail" />
                    </template>
                  </cludo-vue-results>
                  <search-no-results v-else :searchTerm="filterParamaters?.query" />
                  <!-- Pagination -->
                  <cludo-vue-pagination previousLabel='Previous' nextLabel='Next' />
                </div>
              </template>
            </template>

            <div class="rh-column" v-if="RHColumn" v-html="RHColumn"></div>
          </div>

          <!-- Sidebar -->
          <aside class="news-display__aside" role="complementary">
            <!-- Filters -->
            <div class="programmes__filters">
              <SearchFilters :filterParamaters="filterParamaters" :showCategoryFilters="showCategoryFilters" :showDateFilters="showDateFilters" :RHColumn="RHColumn" />
            </div>
          </aside>
        </section>
      </template>
    </cludo-vue>
  </div>
</template>

<script>
import ResultsCount from './components/ResultsCount.vue';
import SearchResult from './components/SearchResult.vue';
import SearchFilters from './components/SearchFilters.vue';
import SearchLoader from './components/SearchLoader.vue';
import SearchNoResults from './components/SearchNoResults.vue';
export default {
  components: {
    ResultsCount,
    SearchResult,
    SearchFilters,
    SearchLoader,
    SearchNoResults,
  },
  name: 'App',
  props: {
    showThumbnail: {
      type: Boolean,
      default: true,
    },
    showCategoryFilters: {
      type: Boolean,
      default: true,
    },
    showDateFilters: {
      type: Boolean,
      default: true,
    },
    RHColumn: {
      type: String,
      default: '',
    },
    topStoryId: {
      type: String,
      default: '',
    },
    pageTitle: {
      type: String,
      default: '',
    },
  },

  methods: {
    // isCheckBoxFilterSelected(checkboxFilter) {
    //   //Check if at least one filter is selected and that filter is not study year === 2026

    //   if (checkboxFilter?.length > 0) {
    //     const selectedCheckBox =
    //       checkboxFilter.filter((el) => el?.checked === true).length || 0;

    //     if (
    //       //If more than one filter is selected return two
    //       selectedCheckBox > 1
    //     ) {
    //       return true;
    //     } else if (
    //       selectedCheckBox === 1 &&
    //       checkboxFilter.filter((el) => el.name === '2026-entry')[0]
    //         ?.checked === false
    //     ) {
    //       return true;
    //     }
    //     return false;
    //   }
    // },

    // checkFilters(filterParamaters) {
    //   if (filterParamaters?.searchFilter?.length > 0) {
    //     return true;
    //   }

    //   if (Object.keys(filterParamaters?.rangeFilter)?.length > 0) {
    //     return true;
    //   }

    //   if (this.isCheckBoxFilterSelected(filterParamaters?.checkboxFilter)) {
    //     return true;
    //   }

    //   if (filterParamaters.sortFilter?.length > 0) {
    //     return true;
    //   }

    //   if (filterParamaters.fieldFilter?.length > 0) {
    //     return true;
    //   }

    //   if (filterParamaters.query) {
    //     return true;
    //   }

    //   return false;
    // },
  },
};
</script>

<style lang="scss">
@import 'scss/main';
</style>
